///? Default IMPORTS
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS
import { fetchPickerStats } from "../../../redux/PickerDashboard/action";

///? Component & Styling IMPORTS
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import "react-day-picker/lib/style.css";
import {
  Divider,
  Input,
  message,
  Spin,
  Table,
  Button,
  Badge,
  TimePicker,
  Modal,
  Select,
} from "antd";

import dayjs from "dayjs";

import {
  DashboardWrapperBox,
  PickerDashboardTable,
  PickerDashboardWrapper,
  PickerModalWrapper,
  PickerSelect,
} from "./PickerStats.styled";
import { fetchPickerReport } from "../../../redux/PickerCheckerHourly/actions";
import { FiSearch } from "react-icons/fi";
// import ToggleWarehouse from "../../../components/WarehouseToggle/toggleWarehouse";
import DashboardBox from "../../../components/DashboardBox/DashboardBox";
import { GrDocumentCsv } from "react-icons/gr";
import { TrendingUpTwoTone } from "@material-ui/icons";
import { width } from "@material-ui/system";
import { warehouseId } from "../../../constants";
import { ROLES } from "../../../constants/index";

///? Constants
const { Option } = Select;
const SelectData = [
  {
    key: null,
    value: "All",
  },
  {
    key: "1",
    value: "Active",
  },
  {
    key: "0",
    value: "Inactive",
  },
];

message.config({
  maxCount: 1,
});
const format = "HH";
let disableSubmitBtnVar = false;

export class PickerStats extends Component {
  state = {
    from: undefined,
    to: undefined,
    loaderSearch: false,
    statLocal: null,
    warehouseId: warehouseId,
    // selectedTags: ["All"],
    isLoaded: false,
    pickerStat: null,
    csvBlock: true,
    currentBox: null,
    toggleClick: false,
    fromTime: undefined,
    fromTimeString: null,
    toTimeString: null,
    toTime: undefined,
    openTimePicker: false,
    disableToTime: true,
    hourlyReport: null,
    active: null,
  };

  componentDidMount = () => {
    let isAdminPicker = null;
    if (
      this.props.loginInfo.AuthData?.userDTO.role.find(
        (o) => o.roleName === ROLES.ADMIN_PICKER_ROLE
      )
    ) {
      isAdminPicker = true;
    }

    if (!isAdminPicker) {
      this.props.history.push("/picker");
    }

    window.onbeforeunload = function () {
      if (disableSubmitBtnVar) {
        return "Data will be lost if you leave the page, are you sure?";
      }
    };

    // let { warehouseId, selectedTags } = this.state;

    // if (this.props.userDto) {
    //   if (this.props.userType) {
    //     warehouseId = 0;
    //     selectedTags = ["All"];
    //   } else {
    //     warehouseId = this.props.userDto.warehouseIdList[0];
    //     selectedTags = this.props.warehouseList[warehouseId]["warehouseName"];
    //   }
    // }

    this.setState(
      {
        // warehouseId: warehouseId,
        // selectedTags: selectedTags,
        isLoaded: true,
        from: this.getStartDate(new Date()),
        to: new Date(),
      },
      () => {
        // this.getPickerStatData();
      }
    );

    if (
      (this.props.userDto &&
        this.props.userDto.role &&
        !this.props.userDto.role.find(
          (o) => o.roleName === ROLES.ADMIN_CHECKER_ROLE
        )) ||
      !this.props.userDto.role.find(
        (o) => o.roleName === ROLES.ADMIN_PICKER_ROLE
      )
    ) {
      this.setState({ csvBlock: true });
    }
  };

  getStartDate = (date) => {
    date.setDate(date.getDate() - 2);
    return date;
  };

  handleFromChange = (from) => {
    this.setState({ from });
  };
  handleToChange = (to) => {
    this.setState({ to }, this.showFromMonth);
  };
  showFromMonth = () => {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), "months") < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };
  DateFormatter = (param) => {
    let result =
      this.state[param].getFullYear() +
      "-" +
      (this.state[param].getMonth() + 1) +
      "-" +
      this.state[param].getDate();
    return result;
  };
  getPickerStatData = (value) => {
    if (Number(this.state.fromTimeString) > Number(this.state.toTimeString)) {
      message.error("Selected From Time is greater than To Time..", 2);
      return;
    }
    disableSubmitBtnVar = true;

    message.loading("Loading Data..., Please Wait!", 0);
    this.setState({ isLoaded: false });
    let { from, to } = this.state;
    if (from && to) {
      this.setState({ isLoaded: false });
      let fromRefined = this.DateFormatter("from");
      let toRefined = this.DateFormatter("to");

      setTimeout(() => {
        if (!this.state.isLoaded) {
          message.loading(
            "This page is taking longer to load than usual, please wait!",
            0
          );
        }
      }, 5000);
      this.props
        .fetchPickerStats({
          access_token: this.props.access_token,
          fromDate: this.state.fromTimeString
            ? fromRefined + " " + this.state.fromTimeString + ":00:00"
            : fromRefined + " 00:00:01",
          toDate: this.state.toTimeString
            ? toRefined + " " + this.state.toTimeString + ":59:59"
            : toRefined + " 23:59:59",
          history: this.props.history,
          isExportCsv: value ? true : null,
          isFreePickerAvailable:
            this.state.currentBox === "Free Pickers Available" ? true : false,
          active: this.state.active,
          body: [this.state.warehouseId],
        })
        .then(() => {
          disableSubmitBtnVar = false;

          message.destroy();
          if (this.props?.stat?.pickerStatsDataError) {
            message.error(
              this.props?.stat?.pickerStatsDataError
                ? this.props?.stat?.pickerStatsDataError
                : "Something went wrong"
            );
            this.setState({ isLoaded: true, statLocal: null });
          } else {
            message.success("Data successfully loaded");
            this.setState(
              {
                isLoaded: true,
                statLocal: this.props?.stat?.pickerStatsDataSuccess,
              },
              () => {
                let tempArray = [];

                let { statLocal } = this.state;
                if (statLocal && statLocal.pickerStats) {
                  statLocal.pickerStats.map((i) => {
                    tempArray.push([
                      {
                        name: "Picking Pending",
                        subName: "Picked",
                        count: i.pickingPendingCount,
                        totalCount: i.pickedCount,
                        type: "pick",
                      },
                      {
                        name: "Assigned",
                        count: i.assignedCount,
                      },
                      {
                        name: "Average Picking TAT (min)",
                        count: i.averagePicking,
                        type: "pick",
                      },
                      {
                        name: "Free Pickers Available",
                        subName: "Pickers Available",
                        count: i.freePickerAvailableCount,
                        totalCount: i.pickerAvailableCount,
                        type: "picker",
                      },
                    ]);
                  });
                }

                this.setState({ pickerStat: tempArray });

                if (value) {
                  window.open(`${this.state.statLocal.filePath}`, "_blank");
                }
              }
            );
          }
        });
    } else {
      message.warn("Please select a date range");
      this.setState({ isLoaded: true });
    }
  };

  dashboradBoxClick = (value) => {
    this.setState(
      {
        toggleClick: value ? true : false,
        currentBox: value ? "Free Pickers Available" : null,
      },
      () => this.getPickerStatData()
    );
  };

  // exportCsvFunc = () => {
  //   this.setState({ isLoaded: false });
  //   let fromRefined = this.DateFormatter("from");
  //   let toRefined = this.DateFormatter("to");

  //   const vals = {
  //     access_token: this.props.access_token,
  //     fromDate: this.state.fromTimeString
  //       ? fromRefined + " " + this.state.fromTimeString + ":00:00"
  //       : fromRefined + " 00:00:01",
  //     toDate: this.state.toTimeString
  //       ? toRefined + " " + this.state.toTimeString + ":59:59"
  //       : toRefined + " 23:59:59",
  //     isPicker: true,
  //   };
  //   this.props.fetchPickerReport(vals).then(() => {
  //     console.log(
  //       "this.props.pickerCheckerReportReducer",
  //       this.props.pickerCheckerReportReducer
  //     );
  //     if (!this.props.pickerCheckerReportReducer.pickerReportSuccess) {
  //       message.error(
  //         this.props.pickerCheckerReportReducer.pickerReportError,
  //         2
  //       );
  //     } else {
  //       this.setState({
  //         hourlyReport: this.props.pickerCheckerReportReducer
  //           .pickerReportSuccess,
  //         isLoaded: true,
  //       });
  //       window.open(
  //         // `${"https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/csv/checkerAndPickerHourlyStats/12_28_038_16_Feb_2023Checkers_Picker_Hourly_details.csv"}`,
  //         `${this.state.hourlyReport.filePath}`,
  //         "_blank"
  //       );
  //     }
  //   });
  // };

  ////? Table search filter
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          //  icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <FiSearch style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    //  render: (text) => (
    //    <Highlighter
    //      highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
    //      searchWords={[this.state.searchText]}
    //      autoEscape
    //      textToHighlight={text.toString()}
    //    />
    //  ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // - Ends //

  // handleWareHouseChange = (data) => {
  //   this.setState(
  //     {
  //       warehouseId: data.warehouseId,
  //       isLoaded: false,
  //       selectedTags: data.selectedTags,
  //     },
  //     () => {
  //       this.getPickerStatData();
  //     }
  //   );
  // };

  render() {
    const { from, to } = this.state;
    let { userDto, warehouseList } = this.props;
    const modifiers = { start: from, end: to };
    const columns = [
      {
        title: "Picker Name",
        dataIndex: "userName",
        key: "userName",
        ...this.getColumnSearchProps("userName"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "",
        dataIndex: "assigned",
        key: "assigned",
        render: (text) => {
          return {
            children: (
              <span>
                {text ? (
                  <Badge color="green" className="statusDots" />
                ) : (
                  <Badge color="yellow" className="statusDots" />
                )}
              </span>
            ),
          };
        },
      },
      {
        title: "Orders Picked ",
        dataIndex: "pickedCount",
        key: "pickedCount",
        sorter: (a, b) => a.pickedCount - b.pickedCount,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "SKU Picked",
        dataIndex: "pickedMedicineCount",
        key: "pickedMedicineCount",
        sorter: (a, b) => a.pickedMedicineCount - b.pickedMedicineCount,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Missing Medicine",
        dataIndex: "missingMedicineCount",
        key: "missingMedicineCount",
        sorter: (a, b) => a.missingMedicineCount - b.missingMedicineCount,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Average Time in min (Per SKU)",
        dataIndex: "averageTimeInMin",
        key: "averageTimeInMin",
        sorter: (a, b) => a.averageTimeInMin - b.averageTimeInMin,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Break Time (Hrs)",
        dataIndex: "breakTime",
        key: "breakTime",
        sorter: (a, b) => a.breakTime - b.breakTime,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Idle Time (Hrs)",
        dataIndex: "idleTime",
        key: "idleTime",
        sorter: (a, b) => a.idleTime - b.idleTime,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Total Time for Picking (Hrs)",
        dataIndex: "totalTimeForPicking",
        key: "totalTimeForPicking",
        sorter: (a, b) => a.totalTimeForPicking - b.totalTimeForPicking,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Total Logged In Time (Hrs)",
        dataIndex: "totalLoggedInTime",
        key: "totalLoggedInTime",
        sorter: (a, b) => a.totalLoggedInTime - b.totalLoggedInTime,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
    ];

    const pickerColumns = [
      {
        title: "User ID",
        dataIndex: "userId",
        key: "userId",
        ...this.getColumnSearchProps("userId"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Free Picker Names",
        dataIndex: "userName",
        key: "userName",
        ...this.getColumnSearchProps("userName"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
    ];
    return (
      <>
        <PickerDashboardWrapper>
          <div className="DateSelect">
            <DayPickerInput
              value={from}
              placeholder="From"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { after: to },
                toMonth: to,
                modifiers,
                numberOfMonths: 2,
                onDayClick: () => this.to.getInput().focus(),
              }}
              onDayChange={this.handleFromChange}
            />

            <DayPickerInput
              ref={(el) => (this.to = el)}
              value={to}
              placeholder="To"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { before: from },
                modifiers,
                month: from,
                fromMonth: from,
                numberOfMonths: 2,
              }}
              onDayChange={this.handleToChange}
            />

            <PickerSelect
              value={this.state.active}
              onChange={(e) =>
                this.setState({
                  active: e,
                })
              }
            >
              {SelectData.map((i, p) => (
                <Option value={i.key} key={p}>
                  {i.value}
                </Option>
              ))}
            </PickerSelect>

            <button
              className="bbtn"
              onClick={() => {
                this.getPickerStatData();
              }}
              // disabled={!this.state.from || !this.state.to}
              disabled={!this.state.isLoaded}
            >
              Search
            </button>
          </div>
          {/* {this.state.csvBlock ? (
            <button
              className="bbtn"
              style={{ width: "max-content" }}
              disabled={!this.state.statLocal || !this.state.isLoaded}
              onClick={this.exportCsvFunc}
            >
              Export CSV <GrDocumentCsv />
            </button>
          ) : (
            ""
          )} */}
          {/* {this.props.userType ? (
            <ToggleWarehouse
              handleWareHouseChange={(data) => this.handleWareHouseChange(data)}
              selectedTags={this.state.selectedTags}
              warehouseId={this.state.warehouseId}
              userDto={userDto}
              warehouseList={warehouseList}
              isLoaded={this.state.isLoaded}
            />
          ) : (
            ""
          )} */}
        </PickerDashboardWrapper>
        {/* <Modal
          open={this.state.openTimePicker}
          onCancel={() =>
            this.setState({
              openTimePicker: !this.state.openTimePicker,
            })
          }
          className="TimeModal"
          footer={null}
        >
          <PickerModalWrapper>
            <div className="timeGroups">
              <label style={{ width: "100px" }}>From Time</label>
              <TimePicker
                format={format}
                onChange={(time, timeString) =>
                  this.setState({
                    fromTime: time && time._d,
                    disableToTime: false,
                    fromTimeString: timeString,
                  })
                }
                // disabledHours={()=>}
              />
            </div>
            <div className="timeGroups">
              <label style={{ width: "100px" }}>To Time</label>
              <TimePicker
                format={format}
                onChange={(time, timeString) =>
                  this.setState({
                    toTime: time && time._d,
                    toTimeString: timeString,
                  })
                }
                disabled={this.state.disableToTime}
              />
            </div>
            <button
              className="bbtn"
              style={{ width: "max-content" }}
              onClick={() =>
                this.setState(
                  {
                    openTimePicker: !this.state.openTimePicker,
                  },
                  this.getPickerStatData(true)
                )
              }
              disabled={!this.state.fromTime || !this.state.toTime}
            >
              Download Report <GrDocumentCsv />
            </button>
          </PickerModalWrapper>
        </Modal> */}
        {this.state.statLocal && (
          <Spin spinning={!this.state.isLoaded}>
            <Divider>Picker Stats</Divider>

            <DashboardWrapperBox>
              {this.state.pickerStat &&
                this.state.pickerStat.length > 0 &&
                this.state.pickerStat[0].map((i, p) => (
                  <DashboardBox
                    name={i.name}
                    subName={i.subName}
                    count={i.count}
                    totalCount={i.totalCount}
                    type={i.type}
                    key={p}
                    onClick={this.dashboradBoxClick}
                    activeBox={this.state.currentBox}
                    toggleClick={this.state.toggleClick}
                    clickable={
                      i.name === "Free Pickers Available" ? true : false
                    }
                  />
                ))}
            </DashboardWrapperBox>

            <Divider style={{ margin: "2.5em  0" }}>
              Picker Dashboard Stats
            </Divider>

            <PickerDashboardTable>
              {this.state.statLocal && (
                <Table
                  dataSource={
                    this.state.currentBox
                      ? this.state.statLocal.freePickerAvailable
                      : this.state.statLocal.pickerPwaStatsDtoList
                  }
                  columns={this.state.currentBox ? pickerColumns : columns}
                  pagination={
                    this.state.currentBox
                      ? this.state.statLocal.freePickerAvailable?.length > 10
                        ? true
                        : false
                      : this.state.statLocal.pickerPwaStatsDtoList?.length > 10
                      ? true
                      : false
                  }
                  bordered
                  scroll={{ x: 700 }}
                />
              )}
            </PickerDashboardTable>
          </Spin>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  stat: state.pickerstatsReducer,
  userDto: state.authReducer?.AuthData?.userDTO,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
  userType: state.authReducer?.userType,
  pickerCheckerReportReducer: state.pickerCheckerReportReducer,
  loginInfo: state.authReducer,
});

export default withRouter(
  connect(mapStateToProps, { fetchPickerStats, fetchPickerReport })(PickerStats)
);
